<div *ngIf="!imageBase64" class="placeholder"></div>
<div *ngIf="imageBase64 && imageUrl" class="container image"
     [ngClass]="{
         'with-canvas': showCanvas,
         'without-canvas': !showCanvas,
         'checkered': showCanvas && canvasType === CanvasType.CHECKERED,
         'dark': showCanvas && canvasType === CanvasType.DARK,
         'light': showCanvas && canvasType === CanvasType.LIGHT
     }">
    <img [src]="imageUrl">
</div>
<div *ngIf="imageBase64 && imageSvg" class="container svg"
     [innerHTML]="imageSvg"
     [ngClass]="{
         'with-canvas': showCanvas,
         'without-canvas': !showCanvas,
         'checkered': showCanvas && canvasType === CanvasType.CHECKERED,
         'dark': showCanvas && canvasType === CanvasType.DARK,
         'light': showCanvas && canvasType === CanvasType.LIGHT
     }">
</div>
